import { Autocomplete, Button } from "src/components";
import crossIcon from "src/assets/cross.svg";
import { useToast } from "src/hooks/useToast";

const ApprovalCard = ({
    onCloseModal,
    approvalBy,
    setApprovalBy,
    onSuccess,
    isApproving,
}: {
    onCloseModal: () => void;
    approvalBy: any;
    setApprovalBy: (approvalBy: any) => void;
    onSuccess: (isSkip: boolean) => void;
    isApproving: boolean;
}) => {

    const { toast } = useToast();

    const handleApproval = async () => {
        if (!approvalBy) {
            toast({ description: "Please select a post approval person", variant: "destructive" });
            return;
        }
        onSuccess(false);
    };

    const handleSkipApproval = () => {
        setApprovalBy(null);
        onSuccess(true);
        onCloseModal();
    };

    const handleSelectionChange = (e: any) => {
        setApprovalBy(e);
    };

    return (
        <div className="flex flex-col gap-y-2 mb-4 w-[340px] max-h-[318px] mx-auto px-6 bg-white p-4 rounded-xl">
            <div className="flex justify-between items-center">
                <p className="text-normal py-1 font-semibold text-[#49484C]">Post Approval</p>
                <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
                    <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
                </Button>
            </div>

            <div>
                <p className="text-sm mb-2 mt-2 font-normal text-[#666666]">By Whom do you want to post approve this invoice?</p>
                <Autocomplete
                    inputClassName="w-full border py-4 border-[#D0D0D0] rounded-md p-2 mt-2 flex items-center h-8"
                    placeholder="Select"
                    suggestionList={[
                        { name: "CA", value: "CA" },
                        { name: "CADS", value: "CADS" },
                    ]}
                    displayKey="name"
                    uniqueKey="value"
                    onSelectionChange={handleSelectionChange}

                />
            </div>
            <div className="flex justify-end gap-x-2 pt-2">
                <Button className="font-normal h-8 bg-gray-200 rounded-md border border-gray-300 shadow-sm" disabled={isApproving} onClick={handleSkipApproval}>
                    Skip post approval
                </Button>{" "}
                <Button
                    disabled={isApproving}
                    isLoading={isApproving}
                    loaderSize="small"
                    className="font-normal text-white h-8 border rounded-md border-[#8051FF] shadow-sm bg-[#8051FF]"
                    onClick={handleApproval}
                >
                    Proceed
                </Button>
            </div>
        </div>
    );
};

export default ApprovalCard;
